<div class="mx-auto w-full max-w-6xl overflow-hidden bg-white">
  <div class="flex flex-col md:flex-row">
    <!-- Order Product Card -->
    <div
      class="flex w-full min-w-0 flex-col gap-4 bg-white dark:bg-gray-800 border-2 py-4 px-4 my-4 sm:flex-row sm:px-5 md:my-5"
      *ngIf="ordesDeails"
    >
      <div
        class="relative flex h-auto w-full shrink-0 items-center justify-center sm:w-40 md:w-60"
      >
        <img
          [src]="productImageUrl + orderimages"
          alt="Product image"
          class="h-36 w-full object-contain rounded-lg sm:h-40"
        />
      </div>
      <div class="flex-auto p-6">
        <h1 class="text-xl font-semibold dark:text-gray-50">
          {{ ordesDeails.items[0]?.name }}
        </h1>
        <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">
          {{
            ordesDeails.items[0]?.product_id?.productDetails?.productDescription
          }}
        </p>
        <p class="mt-1 text-sm font-medium text-gray-800">
          Rs. {{ ordesDeails.total_amount }}
        </p>
        <p class="text-sm text-gray-600">
          Quantity: {{ ordesDeails.items[0]?.quantity }}
        </p>
        <p class="text-sm text-gray-600">
          Payment: {{ ordesDeails.payment_gateway }}
        </p>
      </div>
    </div>

    <!-- Return/Exchange Section -->
    <div class="p-6 md:p-8 m-auto w-full max-w-2xl">
      <div
        class="uppercase tracking-wide text-center text-2xl md:text-3xl text-indigo-600 font-bold mb-6"
      >
        Request Return or Exchange
      </div>

      <div class="mb-6 flex justify-center">
        <nav
          class="flex max-w-full items-center space-x-1 overflow-x-auto rounded-xl bg-purple-100 p-1 dark:bg-purple-900/30"
        >
          <button
            (click)="setValue('case1')"
            [class]="
              value === 'case1'
                ? 'bg-purple-600 text-white'
                : 'text-purple-700 hover:bg-purple-200 dark:text-purple-300'
            "
            class="px-5 py-2 text-sm md:text-lg font-medium rounded-lg transition"
          >
            Return
          </button>
          <button
            (click)="setValue('case2')"
            [class]="
              value === 'case2'
                ? 'bg-purple-600 text-white'
                : 'text-purple-700 hover:bg-purple-200 dark:text-purple-300'
            "
            class="px-5 py-2 text-sm md:text-lg font-medium rounded-lg transition"
          >
            Exchange
          </button>
        </nav>
      </div>

      <div [ngSwitch]="value">
        <!-- RETURN CASE -->
        <div *ngSwitchCase="'case1'">
          <p class="mb-3 font-medium">Why do you want to return this order?</p>

          <select
            [(ngModel)]="selectedReason"
            (change)="checkButtonState()"
            class="w-full p-3 mb-4 border border-purple-500 rounded-lg bg-gray-50 text-purple-900 focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
          >
            <option value="" disabled selected>Please select a reason</option>
            <option value="Product is missing in the packaging">
              Product is missing in the packaging
            </option>
            <option value="Received wrong item">Received wrong item</option>
            <option value="Don't want the product anymore">
              Don't want the product anymore
            </option>
            <option value="Received a broken/damaged item">
              Received a broken/damaged item
            </option>
            <option value="Quality not as expected">
              Quality not as expected
            </option>
            <option value="Don't like the size/fit">
              Don't like the size/fit
            </option>
          </select>

          <textarea
            [(ngModel)]="additionalInfo"
            (input)="checkButtonState()"
            placeholder="Add more details (optional)"
            rows="3"
            class="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
          ></textarea>

          <!-- Video Upload -->
          <!-- <div class="mb-5">
            <label class="block text-sm font-medium text-gray-700 mb-2">Upload Video (Required)</label>
            <input
              type="file"
              accept="video/*"
              (change)="onVideoSelected($event)"
              class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50" />
            <p class="text-xs text-gray-500 mt-1">
              Show the product issue clearly in a short video (max 30 sec recommended).
            </p>
            <p *ngIf="videoFile" class="text-green-600 text-sm mt-1">✓ {{ videoFile.name }}</p>
          </div> -->

          <div class="mb-5">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Upload Video (Required)
            </label>
            <input
              type="file"
              accept="video/*"
              capture="camera"
              (change)="onVideoSelected($event)"
              class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
            />
            <p class="text-xs text-gray-500 mt-1">
              Show the product issue clearly in a short video (max 30 sec
              recommended).
            </p>
            <p *ngIf="videoFile" class="text-green-600 text-sm mt-1">
              ✓ {{ videoFile.name }}
            </p>
          </div>

          <button
            (click)="submitReturnRequest()"
            [disabled]="!isNextEnabled"
            [ngClass]="{
              'bg-purple-600 hover:bg-purple-700': isNextEnabled,
              'bg-gray-400 cursor-not-allowed': !isNextEnabled
            }"
            class="w-full py-3 px-6 text-white font-bold rounded-lg shadow transition"
          >
            Submit Return Request
          </button>
        </div>

        <!-- EXCHANGE CASE -->
        <div *ngSwitchCase="'case2'">
          <p class="mb-3 font-medium">
            Why do you want to exchange this order?
          </p>

          <select
            [(ngModel)]="selectedReasonExchange"
            (change)="checkButtonStateExchange()"
            class="w-full p-3 mb-4 border border-purple-500 rounded-lg bg-gray-50 text-purple-900 focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
          >
            <option value="" disabled selected>Please select a reason</option>
            <option value="wrong">Received wrong item</option>
            <option value="damaged">Received a broken/damaged item</option>
            <option value="quality-issue">Quality not as expected</option>
            <option value="size-issue">Don't like the size/fit</option>
          </select>

          <textarea
            [(ngModel)]="additionalInfoExchange"
            (input)="checkButtonStateExchange()"
            placeholder="Add more details (optional)"
            rows="3"
            class="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
          ></textarea>

          <button
            (click)="exchangeOrderPage()"
            [disabled]="!isNextEnabledExchange"
            [ngClass]="{
              'bg-purple-600 hover:bg-purple-700': isNextEnabledExchange,
              'bg-gray-400 cursor-not-allowed': !isNextEnabledExchange
            }"
            class="w-full py-3 px-6 text-white font-bold rounded-lg shadow transition"
          >
            Request Exchange
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Loading or Error State -->
<div *ngIf="!ordesDeails && !loading" class="text-center py-10 text-red-500">
  Order not found.
</div>
